import React from 'react';

import { CentreVHUViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { CentreVHUFormValues } from '../types';
import { buildRequestDto } from '../utils';

import ModalEditionCentreVHU from './ModalEditionCentreVHU';

interface ModalCreationProps {
  visible: boolean;
  close: () => void;
  refreshDashboard: () => void;
}

function ModalCreation({
  visible,
  close,
  refreshDashboard,
}: ModalCreationProps): React.ReactElement {
  const initials: CentreVHUFormValues = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: CentreVHUFormValues) =>
      AdminFonctionnelControllerApi.createCentreVHUUsingPOST(
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: CentreVHUViolationDtoFormFieldEnum, values: CentreVHUFormValues) =>
      AdminFonctionnelControllerApi.validateCreateCentreVHUFieldUsingPOST(
        field,
        buildRequestDto(values),
      ),
    response => response.centreVHUViolationsDto ?? [],
  );

  return (
    <ModalEditionCentreVHU
      close={close}
      visible={visible}
      title="Créer un centre VHU"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}

export default ModalCreation;
